import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import Container from '@/components/structure/Container';
import { useTranslation } from '@/hooks/useTranslations';
export const Pricing = () => {
    const { t } = useTranslation();
    return (_jsxs(Container, { paddingVertical: {
            'breakpoint.base': 'spacing.32',
            'breakpoint.lg': 'spacing.80',
        }, children: [_jsx(Box, { as: "h2", typography: "typography.headline.20.bold", marginBottom: "spacing.16", children: t('fsrbo.generic.pricing.title') }), _jsx(Box, { display: "flex", flexDirection: {
                    'breakpoint.base': 'column',
                    'breakpoint.lg': 'row',
                }, justifyContent: "space-between", marginBottom: "spacing.16", gap: {
                    'breakpoint.base': 'spacing.24',
                    'breakpoint.lg': 'spacing.64',
                }, children: [...Array(2)].map((_, index) => (_jsx(Box, { flexBasis: "50%", display: "flex", typography: "typography.body.16.regular", minHeight: "sizing.48", flexGrow: "1", whiteSpace: "pre-line", children: t(`fsrbo.generic.pricing.text.item${index + 1}`) }, index))) })] }));
};
